module.exports = __webpack_public_path__ + "static/media/mv02.b1c84511.jpg";